import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { APP_STORE } from '@core/stores/app.store';

export const PROJECT_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const appStore = inject(APP_STORE);

  const projectId = appStore.selectedProjectId();
  if (projectId != null) {
    req = req.clone({
      setHeaders: {
        ProjectId: projectId
      }
    });
  }

  return next(req);
};
